'use strict';

module.exports = '3.32.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 545
// module chunks = 168707334958949